module.exports = __webpack_public_path__ + "img/email.81675be6.svg";